import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { getLotes, deleteLote, getLoteById } from "../helpers/rutaLotes";
import ModalLote from "./ModalLote";
import "../css/tablecajas.css";

// 🔧 Anchos configurables (px o %)
const COL_W = {
  acciones: 120, // razonable para 2 botones
  codlote: 110,
  lote: 420,
};

const TableLotes = () => {
  const [lotes, setLotes] = useState({ data: {}, loading: true });
  const [lote, setLote] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => { consultaLotes(); }, []);
  const consultaLotes = () => {
    getLotes().then((datos) => setLotes({ data: datos, loading: false }));
  };

  const handleClose = () => { setShow(false); consultaLotes(); };
  const handleShow = () => setShow(true);

  const modificaLote = (id) => {
    getLoteById(id).then((resp) => {
      if (resp.ok) { setLote(resp.lote); handleShow(); }
      else { console.error("❌ Error al obtener lote:", resp.error); }
    });
  };

  const eliminarLote = (id) => {
    if (window.confirm("¿Está seguro que desea borrar el lote?")) {
      deleteLote(id).then(consultaLotes);
    }
  };

  const lista = lotes?.data?.lotes || [];

  return (
    <div className="table-container">
      {!lotes.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container lotes-fixed">
              {/* Control de ancho por columna */}
              <colgroup>
                <col style={{ width: COL_W.acciones }} />
                <col style={{ width: COL_W.codlote }} />
                <col style={{ width: COL_W.lote }} />
              </colgroup>

              <thead>
                <tr className="header">
                  <th className="acciones">Acciones</th>
                  <th className="codlote">Nro</th>
                  <th className="lote">Lote</th>
                </tr>
              </thead>

              <tbody>
                {lista.map((c) =>
                  c.activo ? (
                    <tr key={c._id}>
                      <td className="acciones">
                        <button className="btn btn-primary" onClick={() => modificaLote(c._id)} title="Editar">
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button className="btn btn-danger ml-2" onClick={() => eliminarLote(c._id)} title="Eliminar">
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td className="codlote">{c.codlote}</td>
                      <td className="lote text-truncate" title={c.lote || ""}>{c.lote}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalLote show={show} handleClose={handleClose} lote={lote} />
        </>
      )}
    </div>
  );
};

export default TableLotes;
